import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@pfida-finance/ui/components';
import { WIDGET_COLORS } from '../constants/colors';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function CongratsModal({ open, onOpenChange }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle style={{ color: WIDGET_COLORS.primary }}>
            You&apos;re eligible!
          </DialogTitle>
          <DialogClose />
        </DialogHeader>
        <hr className="border-none h-px bg-gray-200 -mx-6" />
        <div
          className="rounded-lg p-5 text-sm leading-relaxed pb-2"
          style={{ backgroundColor: WIDGET_COLORS.green.bg, color: WIDGET_COLORS.green.text }}
        >
          <strong>Congratulations!</strong>
          <br />
          <br />
          While you have been earning your points, you have been helping other families in our
          community become homeowners. Now you have earned enough points, you are eligible to apply
          for finance and it is your turn to receive community help! The date now visible in your
          dashboard is when you can expect us to reach out to you to discuss the exciting next steps.
        </div>
      </DialogContent>
    </Dialog>
  );
}
